<template>
  <svg :width="width"
       :height="height" 
       viewBox="0 0 14 11"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
       role="presentation"
       @click="$emit('click')">
    <path :fill="disabled ? disabledStateColor : iconColor"
          d="M8.27294 9.89749C7.48031 11.0754 5.74699 11.0754 4.95436 9.8975L0.452238 3.20714C-0.441757 1.87862 0.51022 0.0905542 2.11153 0.0905542H11.1158C12.7171 0.0905542 13.6691 1.87862 12.7751 3.20714L8.27294 9.89749Z" />
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
